<template>
    <div class="bg-white">
        <b-container class="mt-2">
            <b-row>
                <b-col md="6" class="d-block-md">
                    <blockquote class="tiktok-embed" cite="https://www.tiktok.com/@tryhsk2024/video/7439915039890427143"
                        data-video-id="7439915039890427143">
                        <section> <a target="_blank" title="@tryhsk2024"
                                href="https://www.tiktok.com/@tryhsk2024?refer=embed">@tryhsk2024</a> Thi thử HSK vừa có
                            quà
                            vừa được chữa chi tiết!<a title="hskonline" target="_blank"
                                href="https://www.tiktok.com/tag/hskonline?refer=embed">#hskonline</a> <a
                                title="tiếngtrung" target="_blank"
                                href="https://www.tiktok.com/tag/ti%E1%BA%BFngtrung?refer=embed">#tiếngtrung</a> <a
                                title="hoctiengtrung" target="_blank"
                                href="https://www.tiktok.com/tag/hoctiengtrung?refer=embed">#hoctiengtrung</a> <a
                                title="tuhoctiengtrung" target="_blank"
                                href="https://www.tiktok.com/tag/tuhoctiengtrung?refer=embed">#tuhoctiengtrung</a> <a
                                title="tiengtrunggiaotiep" target="_blank"
                                href="https://www.tiktok.com/tag/tiengtrunggiaotiep?refer=embed">#tiengtrunggiaotiep</a>
                            <a title="hoctiengtrungquoc" target="_blank"
                                href="https://www.tiktok.com/tag/hoctiengtrungquoc?refer=embed">#hoctiengtrungquoc</a>
                            <a title="tiengtrungquoc" target="_blank"
                                href="https://www.tiktok.com/tag/tiengtrungquoc?refer=embed">#tiengtrungquoc</a> <a
                                title="tienghoa" target="_blank"
                                href="https://www.tiktok.com/tag/tienghoa?refer=embed">#tienghoa</a> <a title="xuhuong"
                                target="_blank" href="https://www.tiktok.com/tag/xuhuong?refer=embed">#xuhuong</a> <a
                                title="tryhsk" target="_blank"
                                href="https://www.tiktok.com/tag/tryhsk?refer=embed">#tryhsk</a> <a target="_blank"
                                title="♬ nhạc nền  - Luyện thi Tiếng Trung TRYHSK"
                                href="https://www.tiktok.com/music/nhạc-nền-Luyện-thi-Tiếng-Trung-TRYHSK-7439915075307146000?refer=embed">♬
                                nhạc nền - Luyện thi Tiếng Trung TRYHSK</a> </section>
                    </blockquote>
                </b-col>
                <b-col class="pt-3" xs="12" md="6">
                    <div>
                        <h2>Chào mừng bạn đến với cổng thi thử</h2>
                        <p class="text-justify">Kho bài thi đánh giá năng lực tiếng Trung chất lượng hàng đầu cho tất cả
                            các
                            trình độ HSK 1, HSK 2, HSK 3, HSK 4, HSK 5, HSK 6. Tất cả các câu hỏi trong đề thi đều được
                            biên
                            soạn bởi các giáo viên có nhiều năm kinh nghiệm, đề thi được xây dựng dựa trên ma trận đề
                            thi
                            thật.</p>
                        
                        <p><strong>Bạn đã có tài khoản trên tryhsk ?</strong></p>
                        <div class="d-flex" style="gap: 10px">
                            <router-link :to="{ name: 'auth-login', query: ($route.query.nextUrl || $route.query.redirect) ? { nextUrl: $route.query.nextUrl || $route.query.redirect } : {} }" class="auth__form__btn">Đã có tài khoản</router-link>
                            <router-link :to="{ name: 'auth-register', query: ($route.query.nextUrl || $route.query.redirect) ? { nextUrl: $route.query.nextUrl || $route.query.redirect } : {} }" class="btn auth__more__btn text-white">Chưa có tài khoản ?</router-link>
                        </div>
                        
                        <p><strong>Đăng ký thi thử cổng thi Tryhsk bạn sẽ nhận được gì ?</strong></p>
                        <p>1. Thoải mái làm đề thi tất cả các cấp độ từ HSK1 đến HSK 6 có trong cổng thi thử và không giới hạn số lần làm</p>
                        <p>2. Bản xếp hạng từng cấp độ, giải thưởng dấp dẫn dành cho những bạn có điểm số xuất sắc</p>
                        <p>3. Tự động chấm đối với các cấp độ không có bài viết. Đối với các phần thi viết, sẽ có chuyên gia tiếng trung tiến hành chấm và chữa bài chi tiết cho thí</p>
                        <p><strong>Ngần ngại gì mà không đăng ký tham gia ngay!!!</strong></p>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    data() {
        return {
            form: {
                email: '',
                password: ''
            },
            show: true,
            isHiddenPassword: true,
            showErrors: false
        }
    },
    computed: {
        ...mapState('auth', ['isLoggedIn', 'error'])
    },
    watch: {
        error(value) {
            if (value != null) {
                this.showErrors = true;
            }
        }
    },
    methods: {
        ...mapActions(`auth`, ['authLogin', 'clearData']),
    },
    beforeDestroy() {
        this.clearData();
        window.localStorage.setItem('tiktok', '1');
    },
    mounted() {
        window.localStorage.setItem('tiktok', '1');
    }
}
</script>

<style scoped>
.lst-action-form {
    display: flex;
    align-items: center;
    gap: 20px;

    span {
        margin-bottom: 1.5rem;
    }
}

.auth__more__btn {
    margin-bottom: 1.5rem;
    background: #0061b0;
    border-radius: 0;
}
</style>